module.exports = __webpack_public_path__ + "static/media/under-dog.74d41a22.svg";